<template>
  <van-popup v-model="show" round position="bottom" @click-overlay="close" @close="close">
    <div class="popupBox CancelOrderPopup">
      <span class="title">取消购买</span>
      <div class="tip defaultMarginBottom">
        确定后订单会被取消，要好好珍惜抢到的购物机会哦~
      </div>
      <div class="subTitle">请选择取消订单的原因（必选）：</div>
      <van-radio-group v-model="radio">
        <van-cell-group :border="false">
          <van-cell v-if="isWaitingSearch" title="找不到" clickable size="large" class="van-cell" :border="false" @click="radio = '1'">
            <template #right-icon>
              <van-radio name="1">
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : unActiveIcon" />
                </template>
              </van-radio>
            </template>
          </van-cell>
          <div class="subTip tip" v-show="radio === '1' && isShowChangeKeyWordBtn">如因关键词无法搜索到商品，可尝试<span class="link" @click="changeKeyWord">更换关键词</span></div>
          <van-cell title="不想买了" clickable @click="radio = '2'" size="large" class="van-cell" :border="false">
            <template #right-icon>
              <van-radio name="2">
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : unActiveIcon" />
                </template>
              </van-radio>
            </template>
          </van-cell>
          <van-cell title="价格不一致" clickable @click="radio = '3'" size="large" class="van-cell" :border="false">
            <template #right-icon>
              <van-radio name="3">
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : unActiveIcon" />
                </template>
              </van-radio>
            </template>
          </van-cell>
          <van-cell title="其他" clickable @click="radio = '4'" size="large" class="van-cell" :border="false">
            <template #right-icon>
              <van-radio name="4">
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : unActiveIcon" />
                </template>
              </van-radio>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
      <div class="buttonBox">
        <div class="tc_btn shCancelBtn status2 tapActive" @click="close">
          暂不取消
        </div>
        <div class="tc_btn status1 tapActive" :class="radio ? 'shPrimaryBtn' : 'statusDisabled'" @click="confirm">确定取消</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { Popup, RadioGroup, Radio, Cell, CellGroup } from 'vant'

export default {
  data() {
    return {
      show: false,
      radio: '',
      activeIcon: require('@/assets/icon/icon1.png'),
      unActiveIcon: require('@/assets/icon/icon2.png')
    }
  },
  components: {
    'van-popup': Popup,
    'van-radio-group': RadioGroup,
    'van-radio': Radio,
    'van-cell': Cell,
    'van-cell-group': CellGroup
  },
  props: {
    // 是否展示弹窗
    isShow: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    // 是否展示切换关键词按钮
    isShowChangeKeyWordBtn: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    // 是否是待搜索状态
    isWaitingSearch: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  },
  watch: {
    isShow(val) {
      this.show = val
    }
  },
  methods: {
    // 关闭
    close() {
      this.$emit('close')
      this.radio = ''
    },
    // 切换关键词
    changeKeyWord() {
      this.$emit('changeKeyWord')
    },
    // 确认取消
    confirm() {
      if (!this.radio) {
        return
      }
      this.$emit('confirm', { orderCancelReason: this.radio })
    }
  }
}
</script>

<style scoped lang="scss">
.popupBox {
  display: flex;
  flex-direction: column;
  padding: 14px 20px 20px;
  box-sizing: border-box;
  .title {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
    align-self: center;
  }
  .defaultMarginBottom {
    margin-bottom: 15px;
  }
  .tip {
    color: #454444;
    background-color: #f3f3f3;
    font-size: 14px;
    padding: 6px 0 6px 8px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 4px;
    .link {
      color: #1989fa;
      padding: 0 4px;
    }
  }
  .subTip {
    position: relative;
    &::before {
      position: absolute;
      left: 8px;
      top: -8px;
      content: '';
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 8px solid #f3f3f3;
    }
  }
  .subTitle {
    color: #929292;
  }
  .van-cell {
    padding: 10px 0;
    .img-icon {
      height: 20px;
    }
  }
  .buttonBox {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 10px;
  }
  .tc_btn {
    width: 8.8em;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 45px;
    margin: 0 3%;
    position: relative;
    border: 1px solid transparent;
    &.status1 {
      background-color: #ed0133;
      color: #fff;
    }
    &.status2 {
      border: 1px solid #333333;
      color: #333333;
    }
    &.statusDisabled {
      background-color: #ccc;
      border: none;
      opacity: 0.8;
    }
  }
}
</style>
